import api from '../Axios'; // Adjust the path if your Axios setup is in a different folder

export const paymentDocumentsApi = {
  // 1. Fetch existing documents
  getPaymentDocuments: async () => {
    const response = await api.get('/api/expert/payment-documents');
    return response.data;
  },

  // 2. Upload the raw physical file to Cloudinary
  uploadDocumentFile: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/api/expert/payment-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // We still need to explicitly tell Axios this is a file upload
      },
    });
    return response.data; 
  },

  // 3. Save the final text and Cloudinary URLs to the database
  savePaymentDocuments: async (documentData: any) => {
    // Content-Type is automatically application/json by default in Axios
    const response = await api.post('/api/expert/payment-documents', documentData);
    return response.data;
  },
};